export const Datepicker = ({ value, onChange, label, required, error, type }) => {
  return (
    <section className="datepicker-main">
      <label className="datepicker-label" htmlFor={label}>
        {label}
        <span>{required ? "Required" : ""}</span>
      </label>
      <input
        id={label}
        name={label}
        className={`datepicker-proper ${error ? "error" : ""}`}
        value={value}
        onChange={e => onChange(e.target.value)}
        type={type}
      />
      <p className="datepicker-error">{error}</p>
    </section>
  );
};
